import { useEffect, useState } from 'react'
import Modal from '@mui/material/Modal';
import './Modal.scss'
import mainservice from '../../services/MainService'
import { Card, CardContent } from '@mui/material'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '30%',
  maxWidth: '90%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  maxHeight: '90%',
  overflow: 'auto',
  p: 4,
};

export default function CustomModal() {
  const [modalContent, setModalContent] = useState(null)
  useEffect(() => {
    mainservice.registerToBroadcast('globalModal', (key, value) => {
      if (key === 'openmodal') {
        setModalContent(value.content)
      }
    })
  }, [])
  function handleClose() {
    setModalContent(null)
  }
  return <Modal
    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
    open={!!modalContent}
    onClick={handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    <Card
      sx={style}
      onClick={(e) => e.stopPropagation()} 
    >
      <CardContent>
        {modalContent}
      </CardContent>
    </Card>
  </Modal>
}
